import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import DefaultLayout from "../components/DefaultLayout";
import CloseButton from "../components/CloseButton";
import {
  Progress,
  Button,
  Tabs,
  DatePicker,
  TimePicker,
  Table,
  message,
  Select,
  Empty,
  Modal,
  Dropdown,
  Menu,
  Checkbox,
} from "antd";
import moment from "moment";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import html2pdf from "html2pdf.js";
import { getUserRole } from "../utils/auth";
import "./Report.css";
import { Swal } from "sweetalert2";
import {
  ArrowUpOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  TableOutlined,
  DollarOutlined,
  DollarCircleOutlined,
  CreditCardOutlined,
  MobileOutlined,
  WalletOutlined,
  QuestionCircleOutlined,
  PrinterOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  FilterOutlined,
  UserOutlined,
  DownOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
// import { PieChart, Pie, Cell, Tooltip, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip } from 'recharts'; // Importing from recharts
import { useCurrency } from "../contexts/ValidationContext";
import { getCurrencySymbol } from "../utils/currencyHelper";
import dayjs from "dayjs";
import config from "../config";
import { Tag, Input } from "antd";
import Invoice from "../components/Invoice.js";
import SettlementReportDatePickerModal from "../components/settlementReportDatePickerModal.js"; // Import the generic modal
import paymentMethodMap from "../utils/paymentMethodMap"; // Import the payment method mapping

const { RangePicker } = DatePicker;
const { RangePicker: TimeRangePicker } = TimePicker;

const cardStyle = {
  border: "1px solid #f0f0f0",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "16px",
  height: "200px",
};

const salesCardStyle = {
  border: "1px solid #f0f0f0",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  height: "150px",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  marginBottom: "12px",
};

const iconStyle = {
  fontSize: "24px",
  color: "#52c41a",
  marginRight: "12px",
};

const progressContainer = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const buttonGroupStyle = {
  marginBottom: "16px",
};



const Report = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [restaurantName, setRestaurantName] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
});

  const [activeTab, setActiveTab] = useState("");
  const [methodOpen, setMethodOpen] = useState(false);
  const handleMethodDropdownVisibleChange = (open) => {
    setMethodOpen(open);
  };
  const [cashierOpen, setCashierOpen] = useState(false);
  const handleCashierDropdownVisibleChange = (open) => {
    setCashierOpen(open);
  };
  const [tableOpen, setTableOpen] = useState(false);
  const handleTableDropdownVisibleChange = (open) => {
    setTableOpen(open);
  };

  //statementReportModal
    const [isShowSettlementReportModal, setShowSettlementReportModal] = useState(false);
    const [settlementReportType, setSettlementReportType] = useState("monthly");
  
    const handleSettlementReportOpenModal = (type) => {
      console.log('handleSettlementReportOpenModal: ',type);
      
      setSettlementReportType(type);
      setShowSettlementReportModal(true);
    };
  
  //Invoice modal
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const invoiceRef = useRef();
  //Invoice modal
  const [transactionData, setTransactionData] = useState([]);
  const [reportFilteredData, setReportFilteredData] = useState([]);
  const [tempTransactionData, setTempTransactionData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [popupModal, setPopupModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [cashierName, setCashierName] = useState([]);
  const [tableNumber, setTableNumber] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedCashier, setSelectedCashier] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);

  const userRole = getUserRole();
  useEffect(() => {
    if (userRole === "admin") {
      setActiveTab("salesReport");
      fetchVoidedItems();
    } else if (userRole === "staff") {
      setActiveTab("todaysOrders");
    }
  }, [userRole]);

  // <!---------------------------------------------- Closing Report --------------------------------------------------->
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [userResponse, setUserResponse] = useState([]);
  const [tableResponse, setTableResponse] = useState([]);

  // Closing report date selection state
  const [closingReportDate, setClosingReportDate] = useState(moment().startOf('day'));
  const [closingReportLoading, setClosingReportLoading] = useState(false);
  const [closingReportTransactionData, setClosingReportTransactionData] = useState([]);

  // Check for current logged-in user
  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      const { token } = auth;
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded.userId); // Set the current user

        // Navigate only if the user is on an invalid page
        if (window.location.pathname === "/login") {
          navigate("/"); // Redirect to the default page only if on login
        }
      } catch (err) {
        console.error("Invalid token", err);
        localStorage.removeItem("auth");
        navigate("/login"); // Redirect to login if token is invalid
      }
    } else {
      navigate("/login"); // Redirect to login if no auth is found
    }
  }, [navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const closeInvoiceModal = () => {
    setSelectedInvoice(null);
    setShowInvoiceModal(false);
  };

  const calculateSelectedInvoiceData = (record) => {
    console.log("line 224: ", record);

    setSelectedInvoice(record);
    setShowInvoiceModal(true);
  };

  const calculateTotalsAndCounts = async (startDate, endDate) => {
    const filterObject = {
      startDate: startDate.clone().startOf("day").utc().toISOString(),
      endDate: endDate.clone().endOf("day").utc().toISOString(),
    };

    const { data } = await axios.post(
      `${apiBaseUrl}/api/payments/dateBetween`,
      filterObject
    );

    const sortedData = data.sort((a, b) =>
      moment(b.date).isAfter(moment(a.date)) ? 1 : -1
    );
    setReportFilteredData(sortedData);

    const excluded = sortedData.filter((transaction) => {
      const transactionDate = moment(transaction.date);
      return (
        transactionDate.isBefore(startDate) || transactionDate.isAfter(endDate)
      );
    });

    const transactionsInRange = sortedData.filter((transaction) => {
      const transactionDate = moment(transaction.date);
      return (
        transactionDate.isSameOrAfter(startDate) &&
        transactionDate.isSameOrBefore(endDate)
      );
    });

    let fromReceiptNo = null;
    let toReceiptNo = null;
    let totalPax = 0;
    let totalTax = 0;
    if (transactionsInRange.length > 0) {
      const sortedTransactions = transactionsInRange
        .filter((transaction) => transaction.invoiceId)
        .sort((a, b) => a.invoiceId.localeCompare(b.invoiceId));

      if (sortedTransactions.length > 0) {
        fromReceiptNo = sortedTransactions[0].invoiceId;
        toReceiptNo =
          sortedTransactions[sortedTransactions.length - 1].invoiceId;
      }
    }
    const allUsersAggregation = transactionsInRange.reduce(
      (acc, transaction) => {
        console.log("voided: ", transaction);
        const method = transaction.method || "Unknown";
        const serviceAmount = (transaction.billAmount?.services || []).reduce(
          (sum, service) => sum + parseFloat(service.totalPrice || 0),
          0
        );
        const grossAmounts =
          parseFloat(transaction.billAmount?.total || 0) + serviceAmount;
        const discount = parseFloat(transaction.billAmount?.discount || 0);
        const netAmount =
          parseFloat(transaction.billAmount?.subTotal || 0) + serviceAmount;
        // const revenue = parseFloat(transaction.billAmount.grandTotal || 0);
        const payable = parseFloat(transaction.billAmount?.payableAmount || 0);

        totalPax += transaction.pax;

        totalTax += (transaction.billAmount?.taxes || []).reduce(
          (sum, tax) => sum + parseFloat(tax.taxAmount || 0),
          0
        );

        if (!acc[method]) {
          acc[method] = {
            count: 0,
            depositCount: 0,
            totalGrossAmountsForEachMethod: 0,
            totalDiscountForEachMethod: 0,
            totalNetSalesForEachMethod: 0,
            totalServiceForEachMethod: 0,
            totalRevenueForEachMethod: 0,
            totalPayableForEachMethod: 0,
            totalDepositForEachMethod: 0,
            items: [],
          };
        }

        acc[method].count += 1;
        acc[method].totalGrossAmountsForEachMethod += grossAmounts;
        acc[method].totalDiscountForEachMethod += discount;
        acc[method].totalNetSalesForEachMethod += netAmount;
        acc[method].totalServiceForEachMethod += serviceAmount;
        acc[method].totalRevenueForEachMethod += payable;
        acc[method].totalPayableForEachMethod += payable;
        acc[method].items.push(transaction);

        if (
          transaction.billAmount?.deposit &&
          transaction.billAmount?.deposit?.haveDeposit
        ) {
          const depositMethod =
            transaction.billAmount.deposit.method || "Unknown";
          const depositAmount = parseFloat(
            transaction.billAmount.deposit.amount || 0
          );

          if (!acc[depositMethod]) {
            acc[depositMethod] = {
              count: 0,
              depositCount: 0,
              totalGrossAmountsForEachMethod: 0,
              totalDiscountForEachMethod: 0,
              totalNetSalesForEachMethod: 0,
              totalServiceForEachMethod: 0,
              totalRevenueForEachMethod: 0,
              totalPayableForEachMethod: 0,
              totalDepositForEachMethod: 0,
              items: [],
            };
          }
          acc[depositMethod].depositCount += 1;
          acc[depositMethod].totalDepositForEachMethod += depositAmount;
          acc[depositMethod].totalRevenueForEachMethod += depositAmount;
          if (depositMethod !== method) {
            acc[depositMethod].items.push(transaction);
          }
        }

        return acc;
      },
      {}
    );

    const cashiersAggregation = transactionsInRange.reduce(
      (acc, transaction) => {
        const cashierName = transaction.cashierName;
        if (!acc[cashierName]) {
          acc[cashierName] = {
            cashierAmount: 0,
            cashierName: cashierName,
          };
        }

        const depositAmount = parseFloat(
          transaction.billAmount?.deposit?.amount || 0
        );

        const payableAmount = parseFloat(
          transaction.billAmount?.payableAmount || 0
        );

        acc[cashierName].cashierAmount += payableAmount + depositAmount;

        return acc;
      },
      {}
    );

    //cashiers
    const cashiers = Object.values(cashiersAggregation);

    const overall = Object.values(allUsersAggregation).reduce(
      (
        acc,
        {
          count,
          depositCount,
          totalGrossAmountsForEachMethod,
          totalDiscountForEachMethod,
          totalNetSalesForEachMethod,
          totalServiceForEachMethod,
          totalRevenueForEachMethod,
          totalPayableForEachMethod,
          totalDepositForEachMethod,
          items,
        }
      ) => {
        acc.totalTransactions += count;
        acc.totalDepositTransactions += depositCount;
        acc.totalGrossAmounts += totalGrossAmountsForEachMethod;
        acc.totalDiscount += totalDiscountForEachMethod;
        acc.totalNetSales += totalNetSalesForEachMethod;
        acc.totalService += totalServiceForEachMethod;
        acc.totalRevenue += totalRevenueForEachMethod;
        acc.totalPayable += totalPayableForEachMethod;
        acc.totalDeposit += totalDepositForEachMethod;
        acc.items.push(items);

        return acc;
      },
      {
        totalTransactions: 0,
        totalDepositTransactions: 0,
        totalGrossAmounts: 0,
        totalDiscount: 0,
        totalNetSales: 0,
        totalService: 0,
        totalRevenue: 0,
        totalPayable: 0,
        totalDeposit: 0,
        items: [],
      }
    );

    return {
      allData: Object.entries(allUsersAggregation).map(
        ([
          method,
          {
            count,
            depositCount,
            totalGrossAmountsForEachMethod,
            totalDiscountForEachMethod,
            totalNetSalesForEachMethod,
            totalServiceForEachMethod,
            totalRevenueForEachMethod,
            totalPayableForEachMethod,
            totalDepositForEachMethod,
            items,
          },
        ]) => ({
          method: paymentMethodMap[method] || method,
          count,
          depositCount,
          totalGrossAmountsForEachMethod:
            totalGrossAmountsForEachMethod.toFixed(2),
          totalDiscountForEachMethod: totalDiscountForEachMethod.toFixed(2),
          totalNetSalesForEachMethod: totalNetSalesForEachMethod.toFixed(2),
          totalServiceForEachMethod: parseFloat(
            totalServiceForEachMethod
          ).toFixed(2),
          totalRevenueForEachMethod: totalRevenueForEachMethod.toFixed(2),
          totalPayableForEachMethod: totalPayableForEachMethod.toFixed(2),
          totalDepositForEachMethod: totalDepositForEachMethod.toFixed(2),
          items,
        })
      ),
      overall,
      fromReceiptNo,
      toReceiptNo,
      totalPax,
      totalTax,
      cashiers,
    };
  };

  const calculateTodaysTotalsAndCounts = (selectedDate = moment(), useClosingReportData = false) => {
    const selectedStart = moment(selectedDate).startOf("day");
    const selectedEnd = moment(selectedDate).endOf("day");
    
    // Use closing report data if specified, otherwise use regular transaction data
    const dataSource = useClosingReportData ? closingReportTransactionData : transactionData;
    

    const todaysTransactions = dataSource.filter((transaction) => {
      const transactionDate = moment(transaction.date);
      return (
        transactionDate.isSameOrAfter(selectedStart) &&
        transactionDate.isSameOrBefore(selectedEnd)
      );
    });

    console.log("todaysTransactions: ", todaysTransactions);

    // Find fromReceiptNo and toReceiptNo for all transactions today
    let fromReceiptNo = null;
    let toReceiptNo = null;
    let totalPax = 0;
    let totalTax = 0;

    if (todaysTransactions.length > 0) {
      const sortedTransactions = todaysTransactions.sort(
        (a, b) => a.invoiceId - b.invoiceId
      );
      fromReceiptNo =
        sortedTransactions[sortedTransactions.length - 1].invoiceId;
      toReceiptNo = sortedTransactions[0].invoiceId;
    }

    console.log("todays transactions", todaysTransactions);

    // Aggregate totals and counts by payment method
    // const currentUserAggregation = todaysTransactions.reduce(
    //   (acc, transaction) => {
    //     const method = transaction.method || "Unknown";
    //     if (transaction.cashierName === currentUser) {
    //       const serviceAmount = (transaction.billAmount.services || []).reduce(
    //         (sum, service) => sum + parseFloat(service.totalPrice || 0),
    //         0
    //       );
    //       const grossAmounts =
    //         parseFloat(transaction.billAmount.total || 0) + serviceAmount;
    //       const discount = parseFloat(transaction.billAmount.discount || 0);
    //       const netAmount =
    //         parseFloat(transaction.billAmount.subTotal || 0) + serviceAmount;
    //       const revenue = parseFloat(transaction.billAmount.grandTotal || 0);
    //       const payable = parseFloat(transaction.billAmount.payableAmount || 0);

    //       totalPax += transaction.pax;

    //       totalTax += (transaction.billAmount.taxes || []).reduce(
    //         (sum, tax) => sum + parseFloat(tax.taxAmount || 0),
    //         0
    //       );

    //       if (!acc[method]) {
    //         acc[method] = {
    //           count: 0,
    //           depositCount: 0,
    //           totalGrossAmountsForEachMethod: 0,
    //           totalDiscountForEachMethod: 0,
    //           totalNetSalesForEachMethod: 0,
    //           totalRevenueForEachMethod: 0,
    //           totalPayableForEachMethod: 0,
    //           totalDepositForEachMethod: 0,
    //           items: [],
    //         };
    //       }

    //       acc[method].count += 1;
    //       acc[method].totalGrossAmountsForEachMethod += grossAmounts;
    //       acc[method].totalDiscountForEachMethod += discount;
    //       acc[method].totalNetSalesForEachMethod += netAmount;
    //       acc[method].totalRevenueForEachMethod += revenue;
    //       acc[method].totalPayableForEachMethod += payable;
    //       acc[method].items.push(transaction);
    //     }

    //     if (
    //       transaction.billAmount.deposit &&
    //       transaction.billAmount.deposit.haveDeposit
    //     ) {
    //       const depositMethod =
    //         transaction.billAmount.deposit.method || "Unknown";
    //       const depositAmount = parseFloat(
    //         transaction.billAmount.deposit.amount || 0
    //       );

    //       if (!acc[depositMethod]) {
    //         acc[depositMethod] = {
    //           count: 0,
    //           depositCount: 0,
    //           totalGrossAmountsForEachMethod: 0,
    //           totalDiscountForEachMethod: 0,
    //           totalNetSalesForEachMethod: 0,
    //           totalServiceForEachMethod: 0,
    //           totalRevenueForEachMethod: 0,
    //           totalPayableForEachMethod: 0,
    //           totalDepositForEachMethod: 0,
    //           items: [],
    //         };
    //       }
    //       acc[depositMethod].depositCount += 1;
    //       acc[depositMethod].totalDepositForEachMethod += depositAmount;
    //       if (depositMethod !== method) {
    //         acc[depositMethod].items.push(transaction);
    //       }
    //     }

    //     return acc;
    //   },
    //   {}
    // );

    const allUsersAggregation = todaysTransactions.reduce(
      (acc, transaction) => {
        const method = transaction.method || "Unknown";
        const serviceAmount = (transaction.billAmount?.services || []).reduce(
          (sum, service) => sum + parseFloat(service.totalPrice || 0),
          0
        );
        const grossAmounts =
          parseFloat(transaction.billAmount?.total || 0) + serviceAmount;
        const discount = parseFloat(transaction.billAmount?.discount || 0);
        const netAmount =
          parseFloat(transaction.billAmount?.subTotal || 0) + serviceAmount;
        // const revenue = parseFloat(transaction.billAmount.grandTotal || 0);
        const payable = parseFloat(transaction.billAmount?.payableAmount || 0);

        if (!acc[method]) {
          acc[method] = {
            count: 0,
            depositCount: 0,
            totalGrossAmountsForEachMethod: 0,
            totalDiscountForEachMethod: 0,
            totalNetSalesForEachMethod: 0,
            totalServiceForEachMethod: 0,
            totalRevenueForEachMethod: 0,
            totalPayableForEachMethod: 0,
            totalDepositForEachMethod: 0,
            items: [],
          };
        }

        acc[method].count += 1;
        acc[method].totalGrossAmountsForEachMethod += grossAmounts;
        acc[method].totalDiscountForEachMethod += discount;
        acc[method].totalNetSalesForEachMethod += netAmount;
        acc[method].totalServiceForEachMethod += serviceAmount;
        acc[method].totalRevenueForEachMethod += payable;
        acc[method].totalPayableForEachMethod += payable;
        acc[method].items.push(transaction);

        if (
          transaction.billAmount?.deposit &&
          transaction.billAmount.deposit.haveDeposit
        ) {
          const depositMethod =
            transaction.billAmount.deposit.method || "Unknown";
          const depositAmount = parseFloat(
            transaction.billAmount.deposit.amount || 0
          );

          if (!acc[depositMethod]) {
            acc[depositMethod] = {
              count: 0,
              depositCount: 0,
              totalGrossAmountsForEachMethod: 0,
              totalDiscountForEachMethod: 0,
              totalNetSalesForEachMethod: 0,
              totalServiceForEachMethod: 0,
              totalRevenueForEachMethod: 0,
              totalPayableForEachMethod: 0,
              totalDepositForEachMethod: 0,
              items: [],
            };
          }
          acc[depositMethod].depositCount += 1;
          acc[depositMethod].totalDepositForEachMethod += depositAmount;
          acc[depositMethod].totalRevenueForEachMethod += depositAmount;
          if (depositMethod !== method) {
            acc[depositMethod].items.push(transaction);
          }
        }

        return acc;
      },
      {}
    );

    const cashiersAggregation = todaysTransactions.reduce(
      (acc, transaction) => {
        const cashierName = transaction.cashierName;
        if (!acc[cashierName]) {
          acc[cashierName] = {
            cashierAmount: 0,
            cashierName: cashierName,
          };
        }

        const depositAmount = parseFloat(
          transaction.billAmount?.deposit.amount || 0
        );
        const payableAmount = parseFloat(
          transaction.billAmount?.payableAmount || 0
        );

        acc[cashierName].cashierAmount += payableAmount + depositAmount;

        return acc;
      },
      {}
    );

    //cashiers
    const cashiers = Object.values(cashiersAggregation);

    // Calculate overall totals
    const overall = Object.values(allUsersAggregation).reduce(
      (
        acc,
        {
          count,
          depositCount,
          totalGrossAmountsForEachMethod,
          totalDiscountForEachMethod,
          totalNetSalesForEachMethod,
          totalServiceForEachMethod,
          totalRevenueForEachMethod,
          totalPayableForEachMethod,
          totalDepositForEachMethod,
          items,
        }
      ) => {
        acc.totalTransactions += count;
        acc.totalDepositTransactions += depositCount;
        acc.totalGrossAmounts += totalGrossAmountsForEachMethod;
        acc.totalDiscount += totalDiscountForEachMethod;
        acc.totalNetSales += totalNetSalesForEachMethod;
        acc.totalService += totalServiceForEachMethod;
        acc.totalRevenue += totalRevenueForEachMethod;
        acc.totalPayable += totalPayableForEachMethod;
        acc.totalDeposit += totalDepositForEachMethod;
        acc.items.push(items);

        return acc;
      },
      {
        totalTransactions: 0,
        totalDepositTransactions: 0,
        totalGrossAmounts: 0,
        totalDiscount: 0,
        totalNetSales: 0,
        totalService: 0,
        totalRevenue: 0,
        totalPayable: 0,
        totalDeposit: 0,
        items: [],
      }
    );

    return {
      // data: Object.entries(currentUserAggregation).map(
      //   ([
      //     method,
      //     {
      //       count,
      //       depositCount,
      //       totalGrossAmountsForEachMethod,
      //       totalDiscountForEachMethod,
      //       totalNetSalesForEachMethod,
      //       totalServiceForEachMethod,
      //       totalRevenueForEachMethod,
      //       totalPayableForEachMethod,
      //       totalDepositForEachMethod,
      //       items,
      //     },
      //   ]) => ({
      //     method: paymentMethodMap[method] || method,
      //     count,
      //     depositCount,
      //     totalGrossAmountsForEachMethod:
      //       totalGrossAmountsForEachMethod.toFixed(2),
      //     totalDiscountForEachMethod: totalDiscountForEachMethod.toFixed(2),
      //     totalNetSalesForEachMethod: totalNetSalesForEachMethod.toFixed(2),
      //     totalServiceForEachMethod: parseFloat(
      //       totalServiceForEachMethod
      //     ).toFixed(2),
      //     totalRevenueForEachMethod: totalRevenueForEachMethod.toFixed(2),
      //     totalPayableForEachMethod: totalPayableForEachMethod.toFixed(2),
      //     totalDepositForEachMethod: totalDepositForEachMethod.toFixed(2),
      //     items,
      //   })
      // ),
      allData: Object.entries(allUsersAggregation).map(
        ([
          method,
          {
            count,
            depositCount,
            totalGrossAmountsForEachMethod,
            totalDiscountForEachMethod,
            totalNetSalesForEachMethod,
            totalServiceForEachMethod,
            totalRevenueForEachMethod,
            totalPayableForEachMethod,
            totalDepositForEachMethod,
            items,
          },
        ]) => ({
          method: paymentMethodMap[method] || method,
          count,
          depositCount,
          totalGrossAmountsForEachMethod:
            totalGrossAmountsForEachMethod.toFixed(2),
          totalDiscountForEachMethod: totalDiscountForEachMethod.toFixed(2),
          totalNetSalesForEachMethod: totalNetSalesForEachMethod.toFixed(2),
          totalServiceForEachMethod: parseFloat(
            totalServiceForEachMethod
          ).toFixed(2),
          totalRevenueForEachMethod: totalRevenueForEachMethod.toFixed(2),
          totalPayableForEachMethod: totalPayableForEachMethod.toFixed(2),
          totalDepositForEachMethod: totalDepositForEachMethod.toFixed(2),
          items,
        })
      ),
      cashiers,
      overall,
      fromReceiptNo,
      toReceiptNo,
      totalPax,
      totalTax,
    };
  };

  console.log(
    "calculate todays totals and counts",
    calculateTodaysTotalsAndCounts()
  );

  const getSetting = async () => {
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/settings/get-settings`
      );
      setRestaurantName(data.name);
    } catch (error) {
      // message.error("Something Went Wrong");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load settings",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  // Calculate closing report data based on selected date
  const closingReportData = useMemo(() => {
    const selectedStart = moment(closingReportDate).startOf("day");
    const selectedEnd = moment(closingReportDate).endOf("day");
    
    const selectedDateTransactions = closingReportTransactionData.filter((transaction) => {
      const transactionDate = moment(transaction.date);
      return (
        transactionDate.isSameOrAfter(selectedStart) &&
        transactionDate.isSameOrBefore(selectedEnd)
      );
    });

    // Calculate totals for selected date
    const selectedDateTotalDiscount = selectedDateTransactions.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.discount || 0),
      0
    );

    const selectedDateTotalNetAmount =
      selectedDateTransactions.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.subTotal || 0),
        0
      ) +
      selectedDateTransactions.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) => {
            return serviceAcc + parseFloat(serviceItem.totalPrice);
          },
          0
        );
        return acc + serviceSum;
      }, 0);

    const selectedDateTotalService = selectedDateTransactions.reduce((acc, curr) => {
      const serviceSum = curr.billAmount?.services.reduce(
        (serviceAcc, serviceItem) => {
          return serviceAcc + parseFloat(serviceItem.totalPrice);
        },
        0
      );
      return acc + serviceSum;
    }, 0);

    const selectedDateTotalGrossAmount =
      selectedDateTransactions.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.total || 0),
        0
      ) +
      selectedDateTransactions.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) => {
            return serviceAcc + parseFloat(serviceItem.totalPrice);
          },
          0
        );
        return acc + serviceSum;
      }, 0);

    const selectedDateTotalPayable = selectedDateTransactions.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.payableAmount || 0),
      0
    );

    const selectedDateTotalTransactions = selectedDateTransactions.length;

    const selectedDateTotalDepositTransactions = selectedDateTransactions.filter(
      (transaction) => transaction.billAmount?.deposit?.haveDeposit === true
    ).length;

    const selectedDateTotalPax = selectedDateTransactions.reduce((acc, curr) => acc + curr.pax, 0);

    const selectedDateTotalTax = selectedDateTransactions.reduce((acc, curr) => {
      const taxSum = curr.billAmount?.taxes.reduce((taxAcc, taxItem) => {
        return taxAcc + parseFloat(taxItem.taxAmount);
      }, 0);
      return acc + taxSum;
    }, 0);

    const selectedDateTotalDeposit = selectedDateTransactions.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.deposit?.amount || 0),
      0
    );

    const selectedDateTotalRevenue = selectedDateTransactions.reduce(
      (acc, curr) =>
        acc +
        parseFloat(curr.billAmount?.deposit?.amount || 0) +
        parseFloat(curr.billAmount?.payableAmount || 0),
      0
    );

    return {
      selectedDateTotalDiscount,
      selectedDateTotalNetAmount,
      selectedDateTotalService,
      selectedDateTotalGrossAmount,
      selectedDateTotalPayable,
      selectedDateTotalTransactions,
      selectedDateTotalDepositTransactions,
      selectedDateTotalPax,
      selectedDateTotalTax,
      selectedDateTotalDeposit,
      selectedDateTotalRevenue,
      selectedDateTransactions
    };
  }, [closingReportDate, closingReportTransactionData]);

  const {
    // data: todaysTotalsAndCounts,
    allData: todaysAllTotalsAndCounts,
    overall,
    cashiers,
  } = useMemo(() => calculateTodaysTotalsAndCounts(closingReportDate, true), [closingReportDate, closingReportTransactionData]);

  const paymentSummary = [
    {
      title: "Payment Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "Transactions",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Deposit Transactions",
      dataIndex: "depositCount",
      key: "depositCount",
    },
    // {
    //   title: "Gross Amount",
    //   dataIndex: "totalGrossAmountsForEachMethod",
    //   key: "totalGrossAmountsForEachMethod",
    //   render: (totalGrossAmountsForEachMethod) =>
    //     `${symbol} ${parseFloat(totalGrossAmountsForEachMethod).toFixed(2)}`,
    // },
    // {
    //   title: "Net Amount",
    //   dataIndex: "totalNetSalesForEachMethod",
    //   key: "totalNetSalesForEachMethod",
    //   render: (totalNetSalesForEachMethod) =>
    //     `${symbol} ${parseFloat(totalNetSalesForEachMethod).toFixed(2)}`,
    // },
    {
      title: "Revenue",
      dataIndex: "totalRevenueForEachMethod",
      key: "totalRevenueForEachMethod",
      render: (totalRevenueForEachMethod) =>
        `${symbol} ${parseFloat(totalRevenueForEachMethod).toFixed(2)}`,
    },
  ];

  const handleClosingReportDateChange = (date) => {
    if (date) {
      setClosingReportDate(moment(date).startOf('day'));
    }
  };

  const handleResetToToday = () => {
    setClosingReportDate(moment().startOf('day'));
  };

  const handleClosingReportPrint = () => {
    const contentToPrint = document.getElementById("closing-report-content");

    const selectedDate = closingReportDate.format("YYYY-MM-DD");

    const fileName = `${currentUser}_daily_closing_report_${selectedDate}.pdf`;

    const contentWithHeader = `
            <div style="padding: 20px; font-family: Arial, sans-serif;">
              <h2 style="text-align: center; margin-bottom: 20px;">Cashier Daily's Closing Report</h2>
              <h3 style="text-align: center; margin-bottom: 20px; color: #666;">Date: ${closingReportDate.format('YYYY-MM-DD')}</h3><br><br>
              <div>${contentToPrint.innerHTML}</div>
            </div>
          `;

    html2pdf()
      .set({
        html2canvas: { scale: 4 }, // pdf清晰度
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      })
      .from(contentWithHeader)
      .save(fileName);
  };
  
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Handlers for changing tabs
  const handleTabChange = (key) => {
    setActiveTab(key);

    if (key !== activeTab) {
      const resetFilters = { ...initialFilters };
      setFilters(resetFilters);
      applyFilters(resetFilters);
    }

    if (key == "salesReport") {
      getTodaySales();
    } else if (key == "closingReport") {
      // For closing report, we need all transaction data to support date selection
      getAllTransactionsForClosingReport();
    }
  };

  const getTodaySales = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/payments/today`);

      const sortedData = data.sort((a, b) =>
        moment(b.date).isAfter(moment(a.date)) ? 1 : -1
      );
      setFilteredData(sortedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTodaySales();
  }, []);

  const getAllTransactions = async () => {
    try {
      const [startDate, endDate] = filters.dateRange || [];

      if (!startDate || !endDate) {
        return;
      }

      // Construct UTC start and end of the selected days
      const filterObject = {
        startDate: startDate.clone().startOf("day").utc().toISOString(), // 00:00:00 UTC of startDate
        endDate: endDate.clone().endOf("day").utc().toISOString(), // 23:59:59.999 UTC of endDate
      };

      // const { data } = [];
      const { data } = await axios.post(
        `${apiBaseUrl}/api/payments/dateBetween`,
        filterObject
      );

      const sortedData = data.sort((a, b) =>
        moment(b.date).isAfter(moment(a.date)) ? 1 : -1
      );

      setTransactionData(sortedData);
      setTempTransactionData(sortedData);

      // Extract unique payment methods from all transactions
      const methods = [...new Set(data.map((item) => item.method))];
      setPaymentMethods(methods);

      //table
      const tableResponse = await axios.get(
        `${apiBaseUrl}/api/tables/get-table`
      );
      setTableResponse(tableResponse.data);

      const tables = [
        ...new Set(tableResponse.data.map((item) => item.table_number)),
      ];
      setTableNumber(tables);

      //user
      const userResponse = await axios.get(`${apiBaseUrl}/api/users/get-user`);

      setUserResponse(userResponse.data);
      // const cashiers = [...new Set(userResponse.data.filter(user => user.role === 'staff').map(user => user.userId))];
      const cashiers = [
        ...new Set(
          userResponse.data
            .filter((user) => user.role === "staff" || user.role === "admin") // Include both staff and admin
            .map((user) => user.userId)
        ),
      ];
      setCashierName(cashiers);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllTransactions();
  }, []);

  const getAllTransactionsForClosingReport = async () => {
    setClosingReportLoading(true);
    try {
      // Fetch all transaction data for the closing report
      const { data } = await axios.get(`${apiBaseUrl}/api/payments`);

      const sortedData = data.sort((a, b) =>
        moment(b.date).isAfter(moment(a.date)) ? 1 : -1
      );

      console.log("Setting closingReportTransactionData:", sortedData.length, "transactions");
      setClosingReportTransactionData(sortedData);

      // Extract unique payment methods from all transactions
      const methods = [...new Set(data.map((item) => item.method))];
      setPaymentMethods(methods);

      //table
      const tableResponse = await axios.get(
        `${apiBaseUrl}/api/tables/get-table`
      );
      setTableResponse(tableResponse.data);

      const tables = [
        ...new Set(tableResponse.data.map((item) => item.table_number)),
      ];
      setTableNumber(tables);

      //user
      const userResponse = await axios.get(`${apiBaseUrl}/api/users/get-user`);

      setUserResponse(userResponse.data);
      const cashiers = [
        ...new Set(
          userResponse.data
            .filter((user) => user.role === "staff" || user.role === "admin")
            .map((user) => user.userId)
        ),
      ];
      setCashierName(cashiers);
    } catch (error) {
      console.log(error);
    } finally {
      setClosingReportLoading(false);
    }
  };

  const getAllTransactionsWithDates = async (startDate, endDate) => {
    try {
      if (!startDate || !endDate) {
        return;
      }

      // Construct UTC start and end of the selected days
      const filterObject = {
        startDate: startDate, // 00:00:00 UTC of startDate
        endDate: endDate, // 23:59:59.999 UTC of endDate
      };

      // const { data } = [];
      const { data } = await axios.post(
        `${apiBaseUrl}/api/payments/dateBetween`,
        filterObject
      );

      const sortedData = data.sort((a, b) =>
        moment(b.date).isAfter(moment(a.date)) ? 1 : -1
      );
      setTransactionData(sortedData);
      setTempTransactionData(sortedData);
      // Extract unique payment methods from all transactions
      const methods = [...new Set(data.map((item) => item.method))];
      setPaymentMethods(methods);
      const tables = [
        ...new Set(tableResponse.map((item) => item.table_number)),
      ];
      setTableNumber(tables);

      const cashiers = [
        ...new Set(
          userResponse
            .filter((user) => user.role === "staff" || user.role === "admin") // Include both staff and admin
            .map((user) => user.userId)
        ),
      ];
      setCashierName(cashiers);

      applyDateFilters(sortedData);
    } catch (error) {
      console.log(error);
      if (error.response?.status === 404) {
        setTransactionData([]);
        setTempTransactionData([]);
        setPaymentMethods([]);
        setTableNumber([]);
        setCashierName([]);
      }
    }
  };

  const formatDateTime = (isoString) => {
    const dateObj = new Date(isoString);
    const date = dateObj.toLocaleDateString().split("T")[0];
    const time = dateObj.toTimeString().split(" ")[0];
    return { date, time };
  };

  const formatCustomDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const getDaySuffix = (day) => {
      if (day % 10 === 1 && day !== 11) return "st";
      if (day % 10 === 2 && day !== 12) return "nd";
      if (day % 10 === 3 && day !== 13) return "rd";
      return "th";
    };

    return `${day}${getDaySuffix(day)} ${month} ${year}`;
  };

  const today = moment();
  const startOfDay = today.clone().startOf("day");
  const endOfDay = today.clone().endOf("day");

  const initialFilters = {
    dateRange: [startOfDay, endOfDay],
    timeRange: null,
    method: null,
    cashier: null,
    table: null,
  };

  const [filters, setFilters] = useState(initialFilters);

  const updateFilters = (newFilters) => {
    setFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters, ...newFilters };
      applyFilters(updatedFilters);
      return updatedFilters;
    });
  };

  const applyFilters = (filters) => {
    const { timeRange, method, cashier, table } = filters;

    const [startTime, endTime] = timeRange || [null, null];

    const filtered = tempTransactionData.filter((transaction) => {
      const transactionTime = moment(transaction.date).format("HH:mm");

      const isWithinTimeRange =
        startTime && endTime
          ? moment(transactionTime, "HH:mm").isBetween(
              moment(startTime, "HH:mm"),
              moment(endTime, "HH:mm"),
              "minute",
              "[]"
            )
          : true;

      const isMethodMatch = method ? transaction.method === method : true;
      const isCashierMatch = cashier
        ? transaction.cashierName === cashier
        : true;
      const isTableMatch = table ? transaction.tableNo === table : true;

      return (
        isWithinTimeRange && isMethodMatch && isCashierMatch && isTableMatch
      );
    });

    const filteredWithMappedMethod = filtered.map((t) => ({
      ...t,
      method: paymentMethodMap[t.method] || t.method,
    }));

    setTransactionData(filteredWithMappedMethod);
  };

  const applyDateFilters = (data) => {
    setTransactionData(data);
  };

  // Handlers for each filter
  const handleDateRangeChange = (dates) => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) return;

    const [startDate, endDate] = dates;

    setFilters((prevFilters) => ({
      ...prevFilters,
      dateRange: dates,
    }));

    // Construct UTC start and end of the selected days
    const filterObject = {
      startDate: startDate.clone().startOf("day").utc().toISOString(), // 00:00:00 UTC of startDate
      endDate: endDate.clone().endOf("day").utc().toISOString(), // 23:59:59.999 UTC of endDate
    };

    getAllTransactionsWithDates(filterObject.startDate, filterObject.endDate);
  };

  const handleTimeRangeChange = (times) => {
    updateFilters({ timeRange: times });
  };

  const handlePaymentMethodChange = (value) => {
    updateFilters({ method: value });
  };

  const handleCashierNameChange = (value) => {
    updateFilters({ cashier: value });
  };

  const handleTableNumberChange = (value) => {
    updateFilters({ table: value });
  };

  const columns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ),
    },
    { title: "User ID", dataIndex: "cashierName" },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => {
        const formattedDate = formatDateTime(date).date;
        return <span>{formattedDate}</span>;
      },
    },
    {
      title: "Time",
      dataIndex: "date",
      render: (date) => {
        const formattedTime = formatDateTime(date).time;
        return <span>{formattedTime}</span>;
      },
    },
    {
      title: "Invoice No.",
      dataIndex: "invoiceId",
      render: (invoiceId, record) => (
        <a
          onClick={() => {
            calculateSelectedInvoiceData(record);
            setShowInvoiceModal(true); // Trigger your modal visibility here
          }}
          style={{
            cursor: "pointer",
            color: "#1890ff", // Ant Design's link blue
            textDecoration: "underline",
          }}
        >
          {invoiceId}
        </a>
      ),
    },
    { title: "Table No.", dataIndex: "tableNo" },
    { title: "Payment Method", dataIndex: "method" },
    {
      title: "Gross Amount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const total = parseFloat(record.billAmount.total || 0);

        const serviceSum = (record.billAmount.services || []).reduce(
          (acc, service) => acc + parseFloat(service.totalPrice || 0),
          0
        );

        const grossAmount = total + serviceSum;

        return <span>{parseFloat(grossAmount).toFixed(2)}</span>;
      },
    },
    {
      title: "Discount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const discount = record.billAmount.discount;
        if (discount !== undefined && discount !== null) {
          return <span>{parseFloat(discount).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
    {
      title: "Net Amount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const subTotal = parseFloat(record.billAmount.subTotal || 0);

        const serviceSum = (record.billAmount.services || []).reduce(
          (acc, service) => acc + parseFloat(service.totalPrice || 0),
          0
        );

        const netAmount = subTotal + serviceSum;

        return <span>{parseFloat(netAmount).toFixed(2)}</span>;
      },
    },
    {
      title: "Services (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const serviceSum = (record.billAmount.services || []).reduce(
          (acc, service) => acc + parseFloat(service.totalPrice || 0),
          0
        );
        return <span>{parseFloat(serviceSum).toFixed(2)}</span>;
      },
    },
    {
      title: "Deposit (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const depositAmount = record.billAmount.deposit.amount;
        if (depositAmount !== undefined && depositAmount !== null) {
          return <span>{parseFloat(depositAmount).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
    {
      title: "Payable Amount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const payableAmount = record.billAmount.payableAmount;
        if (payableAmount !== undefined && payableAmount !== null) {
          return <span>{parseFloat(payableAmount).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
    {
      title: "Revenue (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const depositAmount = record.billAmount.deposit.amount;
        const payableAmount = record.billAmount.payableAmount;
        if (
          depositAmount !== undefined &&
          depositAmount !== null &&
          payableAmount !== undefined &&
          payableAmount !== null
        ) {
          const revenue = parseFloat(payableAmount) + parseFloat(depositAmount);
          return <span>{parseFloat(revenue).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
  ];

  const getVoidedItemsDataByDateRange = (startDate, endDate) => {
    console.log("startDate:", startDate, " endDate: ", endDate);
    console.log("voidedItemsData; ", voidedItemsData);

    const filteredVoidedData = voidedItemsData.reduce(
      (acc, item) => {
        const voidedMoment = moment.utc(item.date).local();
        if (voidedMoment.isBetween(startDate, endDate, undefined, "[]")) {
          acc.totalQuantity += 1;
          acc.totalQuantityOfItems += item.quantity;
          acc.totalAmount += item.amount;
        }
        return acc;
      },
      {
        totalQuantity: 0,
        totalQuantityOfItems: 0,
        totalAmount: 0,
      }
    );
    console.log("filteredVoidedData: ", filteredVoidedData);

    return filteredVoidedData;
  };


  const calculateTotals = (isCalculateTodaySales) => {
    //general
    const todayTotalDiscount = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount.discount || 0),
      0
    );

    const todayTotalNetAmount =
      filteredData.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.subTotal || 0),
        0
      ) +
      filteredData.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) => {
            return serviceAcc + parseFloat(serviceItem.totalPrice);
          },
          0
        );
        return acc + serviceSum;
      }, 0);

    const todayTotalService = filteredData.reduce((acc, curr) => {
      const serviceSum = curr.billAmount?.services.reduce(
        (serviceAcc, serviceItem) => {
          return serviceAcc + parseFloat(serviceItem.totalPrice);
        },
        0
      );
      return acc + serviceSum;
    }, 0);

    const cashiersAggregation = filteredData.reduce((acc, curr) => {
      const cashierName = curr.cashierName;
      if (!acc[cashierName]) {
        acc[cashierName] = {
          cashierAmount: 0,
          cashierName: cashierName,
        };
      }

      const depositAmount = parseFloat(curr.billAmount?.deposit?.amount || 0);
      const payableAmount = parseFloat(curr.billAmount?.payableAmount || 0);

      acc[cashierName].cashierAmount += payableAmount + depositAmount;

      return acc;
    }, {});

    //cashiers
    const cashiers = Object.values(cashiersAggregation);

    const todayTotalGrossAmount =
      filteredData.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.total || 0),
        0
      ) +
      filteredData.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) => {
            return serviceAcc + parseFloat(serviceItem.totalPrice);
          },
          0
        );
        return acc + serviceSum;
      }, 0);

    const todayTotalPayable = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.payableAmount || 0),
      0
    );

    const todayTotalTransactions = filteredData.length;

    const todayTotalDepositTransactions = filteredData.filter(
      (transaction) => transaction.billAmount?.deposit?.haveDeposit === true
    ).length;

    const todayTotalPax = filteredData.reduce((acc, curr) => acc + curr.pax, 0);

    const todayTotalTax = filteredData.reduce((acc, curr) => {
      const taxSum = curr.billAmount.taxes.reduce((taxAcc, taxItem) => {
        return taxAcc + parseFloat(taxItem.taxAmount);
      }, 0);
      return acc + taxSum;
    }, 0);

    const todayTotalDeposit = filteredData.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.deposit?.amount),
      0
    );

    const todayTotalRevenue = filteredData.reduce(
      (acc, curr) =>
        acc +
        parseFloat(curr.billAmount?.deposit?.amount || 0) +
        parseFloat(curr.billAmount?.payableAmount || 0),
      0
    );

    const totalDiscount = transactionData.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.discount || 0),
      0
    );

    const totalNetAmount =
      transactionData.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.subTotal || 0),
        0
      ) +
      transactionData.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) => {
            return serviceAcc + parseFloat(serviceItem.totalPrice);
          },
          0
        );
        return acc + serviceSum;
      }, 0);

    const totalService = transactionData.reduce((acc, curr) => {
      const serviceSum = curr.billAmount?.services.reduce(
        (serviceAcc, serviceItem) => {
          return serviceAcc + parseFloat(serviceItem.totalPrice);
        },
        0
      );
      return acc + serviceSum;
    }, 0);

    const totalGrossAmount =
      transactionData.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.total || 0),
        0
      ) +
      transactionData.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) => {
            return serviceAcc + parseFloat(serviceItem.totalPrice);
          },
          0
        );
        return acc + serviceSum;
      }, 0);

    const totalPayable = transactionData.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.payableAmount || 0),
      0
    );

    const totalRevenue = transactionData.reduce(
      (acc, curr) =>
        acc +
        parseFloat(curr.billAmount?.deposit?.amount || 0) +
        parseFloat(curr.billAmount?.payableAmount || 0),
      0
    );

    const totalTransactions = transactionData.length;

    const totalDepositTransactions = transactionData.filter(
      (transaction) => transaction.billAmount?.deposit?.haveDeposit === true
    ).length;

    const totalPax = transactionData.reduce((acc, curr) => acc + curr.pax, 0);

    const totalTax = transactionData.reduce((acc, curr) => {
      const taxSum = curr.billAmount?.taxes.reduce((taxAcc, taxItem) => {
        return taxAcc + parseFloat(taxItem.taxAmount);
      }, 0);
      return acc + taxSum;
    }, 0);

    const totalDeposit = transactionData.reduce(
      (acc, curr) => acc + parseFloat(curr.billAmount?.deposit?.amount),
      0
    );

    // Function to calculate totals per payment method
    const calculateMethodTotals = (method) => {
      const transactions = isCalculateTodaySales
        ? filteredData
        : transactionData.filter(
            (transaction) => transaction.method === method
          );

      const totalService = transactions.reduce((acc, curr) => {
        const serviceSum = curr.billAmount?.services.reduce(
          (serviceAcc, serviceItem) =>
            serviceAcc + parseFloat(serviceItem.totalPrice),
          0
        );
        return acc + serviceSum;
      }, 0);

      const totalGrossAmount =
        transactions.reduce(
          (acc, curr) => acc + parseFloat(curr.billAmount?.total || 0),
          0
        ) + totalService;

      const totalNetAmount =
        transactions.reduce(
          (acc, curr) => acc + parseFloat(curr.billAmount?.subTotal || 0),
          0
        ) + totalService;

      const totalDiscount = transactions.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.discount || 0),
        0
      );

      const totalPayable = transactions.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.payableAmount || 0),
        0
      );

      const totalTax = transactions.reduce((acc, curr) => {
        const taxSum = curr.billAmount.taxes.reduce(
          (taxAcc, taxItem) => taxAcc + parseFloat(taxItem.taxAmount),
          0
        );
        return acc + taxSum;
      }, 0);

      const totalRevenue = transactions.reduce(
        (acc, curr) =>
          acc +
          parseFloat(curr.billAmount?.payableAmount || 0) +
          parseFloat(curr.billAmount?.deposit?.amount || 0),
        0
      );

      const totalPax = transactions.reduce((acc, curr) => acc + curr.pax, 0);

      return {
        items: transactions.map((transaction) => ({
          invoiceId: transaction.invoiceId,
          revenue:
            parseFloat(transaction.billAmount?.payableAmount) +
            parseFloat(transaction.billAmount?.deposit?.amount),
        })),
        totalGrossAmount: totalGrossAmount.toFixed(2),
        totalDiscount: totalDiscount.toFixed(2),
        totalNetAmount: totalNetAmount.toFixed(2),
        totalService: totalService.toFixed(2),
        totalPayable: totalPayable.toFixed(2),
        totalTransactions: transactions.length,
        totalPax: totalPax.toString(),
        totalTax: totalTax.toFixed(2),
        totalRevenue: totalRevenue.toFixed(2),
      };
    };

    const calculateMethodDeposits = (method) => {
      const transactions = isCalculateTodaySales
        ? filteredData
        : transactionData.filter(
            (transaction) =>
              paymentMethodMap[transaction.billAmount?.deposit?.method] ===
              method
          );

      const totalDeposit = transactions.reduce(
        (acc, curr) => acc + parseFloat(curr.billAmount?.deposit?.amount),
        0
      );

      return totalDeposit.toFixed(2);
    };

    const calculateMethodDepositsTransactions = (method) => {
      const transactions = isCalculateTodaySales
        ? filteredData
        : transactionData.filter(
            (transaction) =>
              paymentMethodMap[transaction.billAmount?.deposit?.method] ===
              method
          );
      return transactions.length;
    };

    // Get totals for each payment method
    const cash = calculateMethodTotals("Cash");
    const visa = calculateMethodTotals("Visa");
    const mastercard = calculateMethodTotals("Mastercard");
    const amex = calculateMethodTotals("American Express");
    const nets = calculateMethodTotals("NETS");
    const paynow = calculateMethodTotals("Pay Now");
    const jcb = calculateMethodTotals("JCB");
    const union = calculateMethodTotals("Union Pay");

    // Get deposits for each payment method
    const cashDeposits = calculateMethodDeposits("Cash");
    const visaDeposits = calculateMethodDeposits("Visa");
    const mastercardDeposits = calculateMethodDeposits("Mastercard");
    const amexDeposits = calculateMethodDeposits("American Express");
    const netsDeposits = calculateMethodDeposits("NETS");
    const paynowDeposits = calculateMethodDeposits("Pay Now");
    const jcbDeposits = calculateMethodDeposits("JCB");
    const unionDeposits = calculateMethodDeposits("Union Pay");

    // Get deposits transaction for each payment method
    const cashDepositTransactions = calculateMethodDepositsTransactions("Cash");
    const visaDepositTransactions = calculateMethodDepositsTransactions("Visa");
    const mastercardDepositTransactions =
      calculateMethodDepositsTransactions("Mastercard");
    const amexDepositTransactions =
      calculateMethodDepositsTransactions("American Express");
    const netsDepositTransactions = calculateMethodDepositsTransactions("NETS");
    const paynowDepositTransactions =
      calculateMethodDepositsTransactions("Pay Now");
    const jcbDepositTransactions = calculateMethodDepositsTransactions("JCB");
    const unionDepositTransactions =
      calculateMethodDepositsTransactions("Union Pay");

    return {
      totalTransactions,
      totalDepositTransactions,
      totalGrossAmount,
      totalDiscount,
      totalNetAmount,
      totalService,
      totalRevenue,
      totalPayable,
      totalDeposit,
      totalPax,
      totalTax,
      cashiers: cashiers,

      todayTotalTransactions,
      todayTotalDepositTransactions,
      todayTotalGrossAmount,
      todayTotalDiscount,
      todayTotalNetAmount,
      todayTotalService,
      todayTotalRevenue,
      todayTotalPayable,
      todayTotalDeposit,
      todayTotalPax,
      todayTotalTax,

      //cash
      totalCashGrossAmount: cash.totalGrossAmount,
      totalCashDiscount: cash.totalDiscount,
      totalCashNetAmount: cash.totalNetAmount,
      totalCashService: cash.totalService,
      totalCashRevenue: cash.totalRevenue,
      totalCashPayable: cash.totalPayable,
      totalCashTransactions: cash.totalTransactions,
      totalCashDeposit: cashDeposits,
      totalCashDepositTransactions: cashDepositTransactions,
      totalCashTax: cash.totalTax,
      cashItems: cash.items,

      // visa
      totalVisaGrossAmount: visa.totalGrossAmount,
      totalVisaDiscount: visa.totalDiscount,
      totalVisaNetAmount: visa.totalNetAmount,
      totalVisaService: visa.totalService,
      totalVisaRevenue: visa.totalRevenue,
      totalVisaPayable: visa.totalPayable,
      totalVisaTransactions: visa.totalTransactions,
      totalVisaDeposit: visaDeposits,
      totalVisaDepositTransactions: visaDepositTransactions,
      totalVisaTax: visa.totalTax,
      visaItems: visa.items,

      // mastercard
      totalMastercardGrossAmount: mastercard.totalGrossAmount,
      totalMastercardDiscount: mastercard.totalDiscount,
      totalMastercardNetAmount: mastercard.totalNetAmount,
      totalMastercardService: mastercard.totalService,
      totalMastercardRevenue: mastercard.totalRevenue,
      totalMastercardPayable: mastercard.totalPayable,
      totalMastercardTransactions: mastercard.totalTransactions,
      totalMastercardDeposit: mastercardDeposits,
      totalMastercardDepositTransactions: mastercardDepositTransactions,
      totalMastercardTax: mastercard.totalTax,
      mastercardItems: mastercard.items,

      // amex
      totalAmexGrossAmount: amex.totalGrossAmount,
      totalAmexDiscount: amex.totalDiscount,
      totalAmexNetAmount: amex.totalNetAmount,
      totalAmexService: amex.totalService,
      totalAmexRevenue: amex.totalRevenue,
      totalAmexPayable: amex.totalPayable,
      totalAmexTransactions: amex.totalTransactions,
      totalAmexDeposit: amexDeposits,
      totalAmexDepositTransactions: amexDepositTransactions,
      totalAmexTax: amex.totalTax,
      amexItems: amex.items,

      // nets
      totalNetsGrossAmount: nets.totalGrossAmount,
      totalNetsDiscount: nets.totalDiscount,
      totalNetsNetAmount: nets.totalNetAmount,
      totalNetsService: nets.totalService,
      totalNetsRevenue: nets.totalRevenue,
      totalNetsPayable: nets.totalPayable,
      totalNetsTransactions: nets.totalTransactions,
      totalNetsDeposit: netsDeposits,
      totalNetsDepositTransactions: netsDepositTransactions,
      totalNetsTax: nets.totalTax,
      netsItems: nets.items,

      // paynow
      totalPaynowGrossAmount: paynow.totalGrossAmount,
      totalPaynowDiscount: paynow.totalDiscount,
      totalPaynowNetAmount: paynow.totalNetAmount,
      totalPaynowService: paynow.totalService,
      totalPaynowRevenue: paynow.totalRevenue,
      totalPaynowPayable: paynow.totalPayable,
      totalPaynowTransactions: paynow.totalTransactions,
      totalPaynowDeposit: paynowDeposits,
      totalPaynowDepositTransactions: paynowDepositTransactions,
      totalPaynowTax: paynow.totalTax,
      paynowItems: paynow.items,

      // jcb
      totalJcbGrossAmount: jcb.totalGrossAmount,
      totalJcbDiscount: jcb.totalDiscount,
      totalJcbNetAmount: jcb.totalNetAmount,
      totalJcbService: jcb.totalService,
      totalJcbRevenue: jcb.totalRevenue,
      totalJcbPayable: jcb.totalPayable,
      totalJcbTransactions: jcb.totalTransactions,
      totalJcbDeposit: jcbDeposits,
      totalJcbDepositTransactions: jcbDepositTransactions,
      totalJcbTax: jcb.totalTax,
      jcbItems: jcb.items,

      // union
      totalUnionGrossAmount: union.totalGrossAmount,
      totalUnionDiscount: union.totalDiscount,
      totalUnionNetAmount: union.totalNetAmount,
      totalUnionService: union.totalService,
      totalUnionRevenue: union.totalRevenue,
      totalUnionPayable: union.totalPayable,
      totalUnionTransactions: union.totalTransactions,
      totalUnionDeposit: unionDeposits,
      totalUnionDepositTransactions: unionDepositTransactions,
      totalUnionTax: union.totalTax,
      unionItems: union.items,
    };
  };

  const {
    totalTransactions,
    totalDepositTransactions,
    totalGrossAmount,
    totalDiscount,
    totalNetAmount,
    totalService,
    totalRevenue,
    totalPayable,
    totalDeposit,
    totalPax,
    totalTax,

    todayTotalTransactions,
    todayTotalDepositTransactions,
    todayTotalGrossAmount,
    todayTotalDiscount,
    todayTotalNetAmount,
    todayTotalService,
    todayTotalRevenue,
    todayTotalPayable,
    todayTotalDeposit,
    todayTotalPax,
    todayTotalTax,
  } = calculateTotals(true);

const handleGenerateSettlementReport = async (selectedValue)=>{
    if (!selectedValue) return;

    // Determine date range based on the settlement report type
    const startDate = selectedValue.clone().startOf(settlementReportType === 'monthly' ? 'month' : 'year');
    const endDate = selectedValue.clone().endOf(settlementReportType === 'monthly' ? 'month' : 'year');
    console.log('startDate :',startDate);
    console.log('endDate :',endDate);

    const {
          allData,
          overall,
          fromReceiptNo,
          toReceiptNo,
          totalPax,
          totalTax,
          cashiers,
        } = await calculateTotalsAndCounts(startDate, endDate);
        const reportData=settlementReportType=== 'monthly'?{
          preparedBy: currentUser,
          month: startDate.format("MMMM YYYY"),
          monthlySummary: {
            totalTransactions: overall.totalTransactions,
            totalDepositTransactions: overall.totalDepositTransactions,
            totalGrossAmount: overall.totalGrossAmounts.toFixed(2),
            totalDiscount: overall.totalDiscount.toFixed(2),
            totalNetAmount: overall.totalNetSales.toFixed(2),
            totalService: overall.totalService.toFixed(2),
            totalRevenue: overall.totalRevenue.toFixed(2),
            totalPayable: overall.totalPayable.toFixed(2),
            totalDeposit: overall.totalDeposit.toFixed(2),
            fromReceiptNo,
            toReceiptNo,
            totalPax,
            totalTax: totalTax.toFixed(2),
          },
          monthlyDetails: allData,
          cashiers: cashiers,
          voidedItemsData: getVoidedItemsDataByDateRange(startDate, endDate),
        }: {
          preparedBy: currentUser,
          year: startDate.format("YYYY"),
          yearlySummary: {
            totalTransactions: overall.totalTransactions,
            totalDepositTransactions: overall.totalDepositTransactions,
            totalGrossAmount: overall.totalGrossAmounts.toFixed(2),
            totalDiscount: overall.totalDiscount.toFixed(2),
            totalNetAmount: overall.totalNetSales.toFixed(2),
            totalService: overall.totalService.toFixed(2),
            totalRevenue: overall.totalRevenue.toFixed(2),
            totalPayable: overall.totalPayable.toFixed(2),
            totalDeposit: overall.totalDeposit.toFixed(2),
            fromReceiptNo,
            toReceiptNo,
            totalPax,
            totalTax: totalTax.toFixed(2),
          },
          yearlyDetails: allData,
          cashiers: cashiers,
          voidedItemsData: getVoidedItemsDataByDateRange(startDate, endDate),
        };


        console.log("JSON for report ", reportData);
        sendReportToBackend(settlementReportType=== 'monthly'?"monthly":"yearly", reportData);

//yearly report

  
       setShowSettlementReportModal(false); // Close the modal
    
  }
  // <!------------------------------------------Daily Sales Report --------------------------------->

  const iconMapping = {
    Cash: <DollarCircleOutlined style={{ ...iconStyle }} />,
    Visa: <CreditCardOutlined style={{ ...iconStyle }} />,
    Mastercard: <CreditCardOutlined style={{ ...iconStyle }} />,
    "American Express": <CreditCardOutlined style={{ ...iconStyle }} />,
    NETS: <CreditCardOutlined style={{ ...iconStyle }} />,
    "Pay Now": <CreditCardOutlined style={{ ...iconStyle }} />,
    JCB: <CreditCardOutlined style={{ ...iconStyle }} />,
    "Union Pay": <CreditCardOutlined style={{ ...iconStyle }} />,
  };

    const getPaymentIcon = (methodName, iconStyle) => {
    if (methodName === 'Cash') {
      return <DollarCircleOutlined style={iconStyle} />;
    }
    return <CreditCardOutlined style={iconStyle} />;
  };

  const [showCash, setShowCash] = useState(true);

  // Calculate payment summary for selected date
  const selectedDatePaymentSummary = useMemo(() => {
    const selectedStart = moment(closingReportDate).startOf("day");
    const selectedEnd = moment(closingReportDate).endOf("day");
    
    const selectedDateTransactions = closingReportTransactionData.filter((transaction) => {
      const transactionDate = moment(transaction.date);
      return (
        transactionDate.isSameOrAfter(selectedStart) &&
        transactionDate.isSameOrBefore(selectedEnd)
      );
    });

    const paymentMethodAggregation = selectedDateTransactions.reduce((acc, transaction) => {
      const method = transaction.method || "Unknown";
      const serviceAmount = (transaction.billAmount?.services || []).reduce(
        (sum, service) => sum + parseFloat(service.totalPrice || 0),
        0
      );
      const grossAmounts = parseFloat(transaction.billAmount?.total || 0) + serviceAmount;
      const discount = parseFloat(transaction.billAmount?.discount || 0);
      const netAmount = parseFloat(transaction.billAmount?.subTotal || 0) + serviceAmount;
      const payable = parseFloat(transaction.billAmount?.payableAmount || 0);

      if (!acc[method]) {
        acc[method] = {
          count: 0,
          depositCount: 0,
          totalGrossAmountsForEachMethod: 0,
          totalDiscountForEachMethod: 0,
          totalNetSalesForEachMethod: 0,
          totalServiceForEachMethod: 0,
          totalRevenueForEachMethod: 0,
          totalPayableForEachMethod: 0,
          totalDepositForEachMethod: 0,
          items: [],
        };
      }

      acc[method].count += 1;
      acc[method].totalGrossAmountsForEachMethod += grossAmounts;
      acc[method].totalDiscountForEachMethod += discount;
      acc[method].totalNetSalesForEachMethod += netAmount;
      acc[method].totalServiceForEachMethod += serviceAmount;
      acc[method].totalRevenueForEachMethod += payable;
      acc[method].totalPayableForEachMethod += payable;
      acc[method].items.push(transaction);

      if (
        transaction.billAmount?.deposit &&
        transaction.billAmount.deposit.haveDeposit
      ) {
        const depositMethod = transaction.billAmount.deposit.method || "Unknown";
        const depositAmount = parseFloat(transaction.billAmount.deposit.amount || 0);

        if (!acc[depositMethod]) {
          acc[depositMethod] = {
            count: 0,
            depositCount: 0,
            totalGrossAmountsForEachMethod: 0,
            totalDiscountForEachMethod: 0,
            totalNetSalesForEachMethod: 0,
            totalServiceForEachMethod: 0,
            totalRevenueForEachMethod: 0,
            totalPayableForEachMethod: 0,
            totalDepositForEachMethod: 0,
            items: [],
          };
        }
        acc[depositMethod].depositCount += 1;
        acc[depositMethod].totalDepositForEachMethod += depositAmount;
        acc[depositMethod].totalRevenueForEachMethod += depositAmount;
        if (depositMethod !== method) {
          acc[depositMethod].items.push(transaction);
        }
      }

      return acc;
    }, {});

    return Object.entries(paymentMethodAggregation).map(
      ([
        method,
        {
          count,
          depositCount,
          totalGrossAmountsForEachMethod,
          totalDiscountForEachMethod,
          totalNetSalesForEachMethod,
          totalServiceForEachMethod,
          totalRevenueForEachMethod,
          totalPayableForEachMethod,
          totalDepositForEachMethod,
          items,
        },
      ]) => ({
        method: paymentMethodMap[method] || method,
        count,
        depositCount,
        totalGrossAmountsForEachMethod: totalGrossAmountsForEachMethod.toFixed(2),
        totalDiscountForEachMethod: totalDiscountForEachMethod.toFixed(2),
        totalNetSalesForEachMethod: totalNetSalesForEachMethod.toFixed(2),
        totalServiceForEachMethod: parseFloat(totalServiceForEachMethod).toFixed(2),
        totalRevenueForEachMethod: totalRevenueForEachMethod.toFixed(2),
        totalPayableForEachMethod: totalPayableForEachMethod.toFixed(2),
        totalDepositForEachMethod: totalDepositForEachMethod.toFixed(2),
        items,
      })
    );
  }, [closingReportDate, closingReportTransactionData]);

  // Calculate payment data for sales report (using filteredData - today's data only)
  const salesReportPaymentData = useMemo(() => {
    const paymentMethodAggregation = filteredData.reduce((acc, transaction) => {
      const method = transaction.method || "Unknown";
      const serviceAmount = (transaction.billAmount?.services || []).reduce(
        (sum, service) => sum + parseFloat(service.totalPrice || 0),
        0
      );
      const grossAmounts = parseFloat(transaction.billAmount?.total || 0) + serviceAmount;
      const discount = parseFloat(transaction.billAmount?.discount || 0);
      const netAmount = parseFloat(transaction.billAmount?.subTotal || 0) + serviceAmount;
      const payable = parseFloat(transaction.billAmount?.payableAmount || 0);

      if (!acc[method]) {
        acc[method] = {
          count: 0,
          depositCount: 0,
          totalGrossAmountsForEachMethod: 0,
          totalDiscountForEachMethod: 0,
          totalNetSalesForEachMethod: 0,
          totalServiceForEachMethod: 0,
          totalRevenueForEachMethod: 0,
          totalPayableForEachMethod: 0,
          totalDepositForEachMethod: 0,
          items: [],
        };
      }

      acc[method].count += 1;
      acc[method].totalGrossAmountsForEachMethod += grossAmounts;
      acc[method].totalDiscountForEachMethod += discount;
      acc[method].totalNetSalesForEachMethod += netAmount;
      acc[method].totalServiceForEachMethod += serviceAmount;
      acc[method].totalRevenueForEachMethod += payable;
      acc[method].totalPayableForEachMethod += payable;
      acc[method].items.push(transaction);

      if (
        transaction.billAmount?.deposit &&
        transaction.billAmount.deposit.haveDeposit
      ) {
        const depositMethod = transaction.billAmount.deposit.method || "Unknown";
        const depositAmount = parseFloat(transaction.billAmount.deposit.amount || 0);

        if (!acc[depositMethod]) {
          acc[depositMethod] = {
            count: 0,
            depositCount: 0,
            totalGrossAmountsForEachMethod: 0,
            totalDiscountForEachMethod: 0,
            totalNetSalesForEachMethod: 0,
            totalServiceForEachMethod: 0,
            totalRevenueForEachMethod: 0,
            totalPayableForEachMethod: 0,
            totalDepositForEachMethod: 0,
            items: [],
          };
        }
        acc[depositMethod].depositCount += 1;
        acc[depositMethod].totalDepositForEachMethod += depositAmount;
        acc[depositMethod].totalRevenueForEachMethod += depositAmount;
        if (depositMethod !== method) {
          acc[depositMethod].items.push(transaction);
        }
      }

      return acc;
    }, {});

    return Object.entries(paymentMethodAggregation).map(
      ([
        method,
        {
          count,
          depositCount,
          totalGrossAmountsForEachMethod,
          totalDiscountForEachMethod,
          totalNetSalesForEachMethod,
          totalServiceForEachMethod,
          totalRevenueForEachMethod,
          totalPayableForEachMethod,
          totalDepositForEachMethod,
          items,
        },
      ]) => ({
        method: paymentMethodMap[method] || method,
        count,
        depositCount,
        totalGrossAmountsForEachMethod: totalGrossAmountsForEachMethod.toFixed(2),
        totalDiscountForEachMethod: totalDiscountForEachMethod.toFixed(2),
        totalNetSalesForEachMethod: totalNetSalesForEachMethod.toFixed(2),
        totalServiceForEachMethod: parseFloat(totalServiceForEachMethod).toFixed(2),
        totalRevenueForEachMethod: totalRevenueForEachMethod.toFixed(2),
        totalPayableForEachMethod: totalPayableForEachMethod.toFixed(2),
        totalDepositForEachMethod: totalDepositForEachMethod.toFixed(2),
        items,
      })
    );
  }, [filteredData]);

  const paymentData = salesReportPaymentData
    .map((item) => ({
      title: item.method || "Other",
      value: parseFloat(item.totalPayableForEachMethod).toFixed(2),
      total: todayTotalRevenue,
      count: item.count,
      icon: getPaymentIcon(item.method, iconStyle),
    }))
    .sort((a, b) => b.value - a.value);

  const depositData = salesReportPaymentData
    .map((item) => ({
      title: item.method || "Other",
      value: parseFloat(item.totalDepositForEachMethod).toFixed(2),
      total: todayTotalRevenue,
      count: item.depositCount,
      icon: getPaymentIcon(item.method, iconStyle),
    }))
    .sort((a, b) => b.value - a.value);

  // <!---------------------------------------- Dropdown button for Print Sales Report -------------------------------------------------------------------------->
  const menuItems = [
    {
      key: "daily",
      label: "Daily Report",
      onClick: () => {
        const {
          allData,
          overall,
          fromReceiptNo,
          toReceiptNo,
          totalPax,
          totalTax,
          cashiers,
        } = calculateTodaysTotalsAndCounts(moment(), false);
        const startDate = moment().startOf("day"); // First day of current month
        const endDate = moment().endOf("day"); // Last day of current month
        const reportData = {
          preparedBy: currentUser,
          dailySummary: {
            totalTransactions: todayTotalTransactions,
            totalDepositTransactions: todayTotalDepositTransactions,
            totalGrossAmount: todayTotalGrossAmount.toFixed(2),
            totalDiscount: todayTotalDiscount.toFixed(2),
            totalNetAmount: todayTotalNetAmount.toFixed(2),
            totalService: todayTotalService.toFixed(2),
            totalRevenue: todayTotalRevenue.toFixed(2),
            totalPayable: todayTotalPayable.toFixed(2),
            totalDeposit: todayTotalDeposit.toFixed(2),
            fromReceiptNo,
            toReceiptNo,
            totalPax: todayTotalPax,
            totalTax: todayTotalTax.toFixed(2),
          },
          dailyDetails: allData,
          cashiers: cashiers,
          voidedItemsData: getVoidedItemsDataByDateRange(startDate, endDate),
        };
        console.log("JSON for report ", reportData);
        sendReportToBackend("daily", reportData);
      },
    },
    {
      key: "monthly",
      label: "Monthly Report",
        onClick: () => handleSettlementReportOpenModal("monthly")
    },
    {
      key: "yearly",
      label: "Yearly Report",
        onClick: () => handleSettlementReportOpenModal("yearly")
    },
  ];

  const sendReportToBackend = async (reportType, reportData) => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;
    const selectedPrinterId = localStorage.getItem("selectedPrinterId");
    try {
      let payload = {};

      switch (reportType) {
        case "daily":
          payload = {
            title: "Daily Settlement Report",
            preparedBy: reportData.preparedBy,
            date: new Date().toLocaleDateString(),
            time: new Date().toLocaleTimeString(),
            summary: reportData.dailySummary || [],
            details: reportData.dailyDetails || [],
            selectedPrinterId: selectedPrinterId,
            cashiers: reportData.cashiers,
            voidedItemsData: reportData.voidedItemsData,
          };
          break;

        case "monthly":
          payload = {
            title: `Monthly Settlement Report (${reportData.month})`,
            preparedBy: reportData.preparedBy,
            date: new Date().toLocaleDateString(),
            time: new Date().toLocaleTimeString(),
            summary: reportData.monthlySummary || [],
            details: reportData.monthlyDetails || [],
            selectedPrinterId: selectedPrinterId,
            cashiers: reportData.cashiers,
            voidedItemsData: reportData.voidedItemsData,
          };
          break;

        case "yearly":
          payload = {
            title: `Yearly Settlement Report (${reportData.year})`,
            preparedBy: reportData.preparedBy,
            date: new Date().toLocaleDateString(),
            time: new Date().toLocaleTimeString(),
            summary: reportData.yearlySummary || {}, // Ensure object for yearly summary
            details: reportData.yearlyDetails || [], // Ensure array for yearly details
            selectedPrinterId: selectedPrinterId,
            cashiers: reportData.cashiers,
            voidedItemsData: reportData.voidedItemsData,
          };
          break;

        default:
          throw new Error("Invalid report type");
      }

      const response = await axios.post(
        `${apiBaseUrl}/api/printreport`,
        payload
      );
      console.log("Payload settlement", payload);

      if (response.data.success) {
        message.success(
          `${
            reportType.charAt(0).toUpperCase() + reportType.slice(1)
          } report print successfully`
        );
      } else {
        throw new Error(response.data.message || "Failed to send report data.");
      }
    } catch (error) {
      console.error("Error sending report data to backend:", error);
      message.error("Failed to send report data");
    }
  };

  // <!---------------------------------------- Voided record -------------------------------------------------------------------------->

  const [voidedItemsData, setVoidedItemsData] = useState([]);
  const [voidedItemsLoading, setVoidedItemsLoading] = useState(false);

  const [voidedItemsFilters, setVoidedItemsFilters] = useState({
    dateRange: [startOfDay, endOfDay],
    timeRange: null,
    cashier: null,
    table: null,
  });

  const applyVoidedItemsFilters = (filters) => {
    const { dateRange, timeRange, cashier, table } = filters;
    const [startDate, endDate] = dateRange || [];
    const endOfDay = endDate ? endDate.clone().endOf("day") : null;
    const [startTime, endTime] = timeRange || [null, null];

    const filtered = voidedItemsData.filter((item) => {

      if (!item.date || !item.time || !moment(item.date).isValid() || !moment(item.time, "HH:mm").isValid()) {
        return false;
      }
      const itemDate = moment(item.date);
      const itemTime = moment(item.time).format("HH:mm");

      const isWithinDateRange =
        startDate && endOfDay
          ? itemDate.isSameOrAfter(startDate, "day") &&
            itemDate.isSameOrBefore(endOfDay, "day")
          : true;

      const isWithinTimeRange =
        startTime && endTime
          ? moment(itemTime, "HH:mm").isBetween(
              moment(startTime, "HH:mm"),
              moment(endTime, "HH:mm"),
              "minute",
              "[]"
            )
          : true;

      const isCashierMatch = cashier ? item.userId === cashier : true;
      const isTableMatch = table
        ? String(item.tableNumber) === String(table)
        : true;

      return (
        isWithinDateRange && isWithinTimeRange && isCashierMatch && isTableMatch
      );
    });

    setFilteredVoidedItems(filtered);
  };

  const [filteredVoidedItems, setFilteredVoidedItems] = useState([]);

  const fetchVoidedItems = async () => {
    setVoidedItemsLoading(true);
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/orders/voided-items`);
      setVoidedItemsData(data);
      // setFilteredVoidedItems(data); // Initialize filtered data
      applyVoidedItemsFilters(voidedItemsFilters); // Apply initial filters
    } catch (error) {
      console.error("Error fetching voided items:", error);
      message.error("Failed to fetch voided items.");
    } finally {
      setVoidedItemsLoading(false);
    }
  };

  const handleVoidedItemsDateRangeChange = (dates) => {
    const newFilters = { ...voidedItemsFilters, dateRange: dates };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const handleVoidedItemsTimeRangeChange = (times) => {
    const newFilters = { ...voidedItemsFilters, timeRange: times };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const handleVoidedItemsCashierChange = (value) => {
    const newFilters = { ...voidedItemsFilters, cashier: value };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const handleVoidedItemsTableChange = (value) => {
    const newFilters = { ...voidedItemsFilters, table: value };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const voidReasonEnum = {
    hygiene_problem: "Hygiene Problem",
    waiting_too_long: "Waiting too long",
    wrong_item: "Wrong item",
    other: "Other",
  };

  const voidedItemsColumns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ),
    },
    { title: "User ID", 
      dataIndex: "userId",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const uniqueUsers = Array.from(new Set(filteredVoidedItems.map(row => row.userId))).sort();
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={uniqueUsers.map(user => ({ label: user, value: user }))}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => value == null ? true : value.includes(record.userId),
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (text) =>
        text ? new Date(text).toISOString().split("T")[0] : "-",
    },
    {
      title: "Time",
      dataIndex: "time",
      render: (text) =>
        text ? new Date(text).toTimeString().split(" ")[0] : "-",
    },
    { title: "Order No.", dataIndex: "orderId",
      sorter: (a, b) => a.orderId.localeCompare(b.orderId),
      onFilter: (value, record) => record.orderId.toLowerCase().includes(value.toLowerCase()),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      showSorterTooltip: false,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    { title: "Table No.", dataIndex: "tableNumber",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const uniqueTables = Array.from(
          new Set(filteredVoidedItems.map(row => row.tableNumber))
        ).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b)));
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={uniqueTables.map(table => ({ label: table, value: table }))}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => String(record.tableNumber) === String(value),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }), },
    { title: "Item Name", dataIndex: "itemName",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const uniqueItems = Array.from(
          new Set(filteredVoidedItems.map(row => row.itemName))
        ).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b)));
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={uniqueItems.map(name => ({
                label: name,
                value: name
              }))}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8, maxHeight: 200, overflowY: 'auto' }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => String(record.itemName) === String(value),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    { title: "Quantity", dataIndex: "quantity",
      sorter: (a, b) => Number(a.quantity) - Number(b.quantity),
      showSorterTooltip: false,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }), 
    },
    {
      title: "Void Reason",
      dataIndex: "voidReason",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const uniqueReasons = Array.from(
          new Set(filteredVoidedItems.map(row => row.voidReason))
        ).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b)));
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={uniqueReasons.map(reason => ({
                label: voidReasonEnum[reason] || reason,
                value: reason
              }))}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => String(record.voidReason) === String(value),
      render: (value) => voidReasonEnum[value] || value,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    // {
    //   title: `Amount (${symbol})`,
    //   dataIndex: 'amount',
    //   render: (amount) => `${symbol} ${amount?.toFixed(2) || '0.00'}`
    // },
  ];

  const handleVoidedItemsPrint = () => {
    if (voidedItemsData.length === 0) {
      message.warning("No voided items to export.");
      return;
    }

    const totalQuantity = voidedItemsData.reduce(
      (sum, item) => sum + (item.quantity || 0),
      0
    );

    const ws = XLSX.utils.json_to_sheet(
      voidedItemsData.map((item, index) => ({
        No: index + 1,
        "User ID": item.userId,
        Date: moment(item.date).format("YYYY-MM-DD"),
        Time: item.time ? moment(item.time).format("HH:mm:ss") : "-",
        "Order No.": item.orderId,
        "Table No.": item.tableNumber,
        "Item Name": item.itemName,
        Quantity: item.quantity,
        "Void Reason": voidReasonEnum[item.voidReason] || item.voidReason,
        // [`Amount (${symbol})`]: item.amount?.toFixed(2) || '0.00',
      }))
    );

    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          "", // No
          "", // User ID
          "", // Date
          "", // Time
          "", // Order No.
          "", // Table No.
          "Total Quantity:", // Label
          totalQuantity, // Total quantity value
        ],
      ],
      { origin: -1 } // Add at the end
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Voided Items");

    const filename = `voided_items_${moment().format("YYYY-MM-DD")}.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  useEffect(() => {
    if (activeTab === "voidedItems") {
      fetchVoidedItems();
      applyVoidedItemsFilters(voidedItemsFilters);
    }
  }, [activeTab]);

  useEffect(() => {
    if (voidedItemsData.length > 0) {
      applyVoidedItemsFilters(voidedItemsFilters);
    }
  }, [voidedItemsData]);

  //  Today's Order  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [todaysOrdersData, setTodaysOrdersData] = useState([]);
  const [todaysOrdersLoading, setTodaysOrdersLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const sortedData = [...todaysOrdersData].sort((a, b) =>
    b.order_time.localeCompare(a.order_time)
  );

  const filteredTodaysOrders = useMemo(() => {
    if (!searchTerm) return sortedData;

    const lowerCaseSearch = searchTerm.toLowerCase();

    return sortedData.filter((order) => {
      // Search in order ID
      if (order.oid.toLowerCase().includes(lowerCaseSearch)) return true;

      // Search in table number
      if (
        order.order_tablenumber &&
        order.order_tablenumber
          .toString()
          .toLowerCase()
          .includes(lowerCaseSearch)
      )
        return true;

      // Search in order ID
      if (
        (order.orUserId &&
          order.orUserId.toString().toLowerCase().includes(lowerCaseSearch)) ||
        (!order.orUserId && "client".includes(lowerCaseSearch))
      )
        return true;

      // // Search in order items
      // const hasMatchingItem = order.order_items.some(item =>
      //   item.product.name.toLowerCase().includes(lowerCaseSearch)
      // );
      // if (hasMatchingItem) return true;

      // // Search in voided items
      // const hasMatchingVoidItem = order.void_items.some(item =>
      //   item.product.name.toLowerCase().includes(lowerCaseSearch)
      // );
      // if (hasMatchingVoidItem) return true;

      return false;
    });
  }, [sortedData, searchTerm]);

  const todaysOrdersColumns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ),
    },
    {
      title: "Order by",
      dataIndex: "orUserId",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const uniqueUsers = Array.from(
          new Set(filteredTodaysOrders.map(row => row.orUserId || "Client"))
        );
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={uniqueUsers.map(user => ({ label: user, value: user }))}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => (record.orUserId || "Client") === value,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
      render: (value) => (value ? value : "Client"),
    },
    {
      title: "Order ID",
      dataIndex: "oid",
      sorter: (a, b) => a.oid.localeCompare(b.oid),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Order ID"
            value={selectedKeys[0]}
            onChange={e => {
              setSelectedKeys(e.target.value ? [e.target.value] : []);
              confirm({ closeDropdown: false });
            }}
            style={{ marginBottom: 8, display: 'block' }}
            onPressEnter={() => confirm()}
          />
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            style={{ width: '100%' }}
          >
            Reset
          </Button>
        </div>
      ),
      onFilter: (value, record) => record.oid.toLowerCase().includes(value.toLowerCase()),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      showSorterTooltip: false,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Table No.",
      dataIndex: "order_tablenumber",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const uniqueTables = Array.from(
          new Set(filteredTodaysOrders.map(row => row.order_tablenumber))
        ).filter(Boolean).sort((a, b) => String(a).localeCompare(String(b)));
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={uniqueTables.map(table => ({ label: table, value: table }))}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => String(record.order_tablenumber) === String(value),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Date",
      dataIndex: "order_date",
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Time",
      dataIndex: "order_time",
      sorter: (a, b) => {
        return a.order_time.localeCompare(b.order_time);
      },
      showSorterTooltip: false,
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Order Items",
      dataIndex: "order_items",
      render: (items) => (
        <div>
          {items.map((item, i) => (
            <div key={i}>
              {item.product.name} x {item.quantity}
            </div>
          ))}
        </div>
      ),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Voided Items",
      dataIndex: "void_items",
      render: (items) => (
        <div>
          {items.map((item, i) => (
            <div key={i}>
              {item.product.name} x {item.quantity}
            </div>
          ))}
        </div>
      ),
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
    },
    {
      title: "Status",
      dataIndex: "order_progressstatus",
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const statusOptions = [
          { label: "In Progress", value: "inprogress" },
          { label: "Paid", value: "Paid" },
          { label: "Voided", value: "Void" },
        ];
        return (
          <div style={{ padding: 8 }}>
            <Checkbox.Group
              options={statusOptions}
              value={selectedKeys}
              onChange={vals => {
                setSelectedKeys(vals);
                confirm({ closeDropdown: false });
              }}
              style={{ display: 'flex', flexDirection: 'column', marginBottom: 8 }}
            />
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: '100%' }}
            >
              Reset
            </Button>
          </div>
        );
      },
      onFilter: (value, record) => {
        if (value === "inprogress") {
          return record.order_progressstatus === "" || record.order_progressstatus === "Kitchen";
        }
        return record.order_progressstatus === value;
      },
      onCell: () => ({
        style: { verticalAlign: "top" },
      }),
      render: (status) => {
        let displayText = status;
        let color = "default";

        if (status === "" || status === "Kitchen") {
          displayText = "In Progress";
          color = "orange";
        } else if (status === "Paid") {
          color = "green";
        } else if (status === "Void") {
          displayText = "Voided";
          color = "red";
        }
        return <Tag color={color}>{displayText}</Tag>;
      },
    },
  ];

  const fetchTodaysOrders = async () => {
    setTodaysOrdersLoading(true);
    try {
      const { data } = await axios.get(
        `${apiBaseUrl}/api/orders/get-today-orders`
      );
      setTodaysOrdersData(data);
    } catch (error) {
      console.error("Error fetching today's orders:", error);
      message.error("Failed to fetch today's orders");
    } finally {
      setTodaysOrdersLoading(false);
    }
  };

    const [showAmounts, setShowAmounts] = useState(false);

  useEffect(() => {
    if (activeTab === "todaysOrders") {
      fetchTodaysOrders();
    } else if (activeTab === "closingReport" && closingReportTransactionData.length === 0) {
      // Load all transaction data for closing report if not already loaded
      getAllTransactionsForClosingReport();
    }
  }, [activeTab]);


  // <!---------------------------------------- Layout -------------------------------------------------------------------------->

  return (
    <DefaultLayout showSearch={false} contentStyle={{ padding: '4px 34px 34px 34px' }}>
      <>
        <style>
          {`
            .custom-closing-card {
              border: 1px solid rgb(192, 192, 192); 
              padding: 20px ;
            }
            `}
        </style>
      </>
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <h1>Report</h1>
        <Button type="default" style={{ width: '150px' }} onClick={handlePrint}>
          <PrinterOutlined /> Print
        </Button>
      </div> */}

      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        {userRole === "admin" && (
          <>
            <Tabs.TabPane tab="Daily Sales Report " key="salesReport">
              {/* POS-STYLE HEADER (show only the current day) */}
              <div className="pos-report-header">
                <div className="pos-report-header-left">
                  <div className="pos-logo-circle">
                    <span role="img" aria-label="logo">🍽️</span>
                  </div>
                  <div className="pos-report-title-group">
                    <div className="pos-report-date pos-report-date-large">{formatCustomDate(currentTime)}</div>
                  </div>
                  </div>
                  <Dropdown overlay={<Menu items={menuItems} />} placement="bottomRight" trigger={['click']}>
                  <Button type="primary" className="pos-print-btn">
                    <PrinterOutlined style={{ marginRight: 8, fontSize: 20 }} /> Print Settlement
                    </Button>
                  </Dropdown>
                  <SettlementReportDatePickerModal
                    open={isShowSettlementReportModal}
                    settlementReportType={settlementReportType} // 4. Pass the reportType to the modal
                    onCancel={() => setShowSettlementReportModal(false)}
                    onGenerate={handleGenerateSettlementReport}
                  />
                </div>

              {/* KEY METRICS CARDS (smaller) */}
              <div className="pos-metrics-row pos-metrics-row-small">
                <div className="pos-metric-card pos-metric-card-small metric-revenue">
                  <div className="pos-metric-icon pos-metric-icon-small"><DollarCircleOutlined /></div>
                  <div className="pos-metric-label pos-metric-label-small">Total Revenue Today</div>
                  <div className="pos-metric-value pos-metric-value-small">{showAmounts ? `${symbol} ${parseFloat(todayTotalRevenue).toFixed(2)}` : '****'}</div>
                      <Button
                        type="text"
                        icon={showAmounts ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                        onClick={() => setShowAmounts((prev) => !prev)}
                    className="pos-metric-eye pos-metric-eye-small"
                      />
                    </div>
                <div className="pos-metric-card pos-metric-card-small metric-transactions">
                  <div className="pos-metric-icon pos-metric-icon-small"><ShoppingCartOutlined /></div>
                  <div className="pos-metric-label pos-metric-label-small">Total Transactions</div>
                  <div className="pos-metric-value pos-metric-value-small">{todayTotalTransactions}</div>
                  </div>
                <div className="pos-metric-card pos-metric-card-small metric-average">
                  <div className="pos-metric-icon pos-metric-icon-small"><WalletOutlined /></div>
                  <div className="pos-metric-label pos-metric-label-small">Average Sale</div>
                  <div className="pos-metric-value pos-metric-value-small">{showAmounts ? `${symbol} ${todayTotalTransactions > 0 ? (todayTotalRevenue / todayTotalTransactions).toFixed(2) : '0.00'}` : '****'}</div>
                </div>
                <div className="pos-metric-card pos-metric-card-small metric-pax">
                  <div className="pos-metric-icon pos-metric-icon-small"><UserOutlined /></div>
                  <div className="pos-metric-label pos-metric-label-small">Total Pax</div>
                  <div className="pos-metric-value pos-metric-value-small">{todayTotalPax}</div>
                </div>
              </div>
              
              {/* PAYMENT METHOD CARDS */}
              <div className="pos-section-title">Revenue by Payment Method</div>
              <div className="pos-grid-cards">
                {(() => {
                  const filtered = paymentData.filter(item => Number(item.value) > 0);
                  return filtered.length > 0
                    ? filtered.map((item) => (
                        <div className="pos-pay-card" key={item.title}>
                          <div className="pos-pay-icon">{item.icon}</div>
                          <div className="pos-pay-title">{item.title}</div>
                          <div className="pos-pay-value">{showAmounts ? `${symbol} ${item.value}` : '****'}</div>
                          <div className="pos-pay-progress">
                            <Progress percent={((item.value / item.total) * 100).toFixed(1)} showInfo={false} strokeColor="#e56717" trailColor="#f0f0f0" />
                          </div>
                          <div className="pos-pay-footer">
                            <span>Transactions: {item.count}</span>
                            <span className="pos-pay-percent">{((item.value / item.total) * 100).toFixed(1)}%</span>
                          </div>
                        </div>
                      ))
                    : <Empty description="No Data Available" style={{ minWidth: 300 }} />;
                })()}
              </div>

              {/* DEPOSIT METHOD CARDS */}
              <div className="pos-section-title">Deposit by Payment Method</div>
              <div className="pos-grid-cards">
                {(() => {
                  const filtered = depositData.filter(item => Number(item.value) > 0);
                  return filtered.length > 0
                    ? filtered.map((item) => (
                        <div className="pos-pay-card" key={item.title}>
                          <div className="pos-pay-icon">{item.icon}</div>
                          <div className="pos-pay-title">{item.title}</div>
                          <div className="pos-pay-value">{showAmounts ? `${symbol} ${item.value}` : '****'}</div>
                          <div className="pos-pay-progress">
                            <Progress percent={((item.value / item.total) * 100).toFixed(1)} showInfo={false} strokeColor="#e56717" trailColor="#f0f0f0" />
                          </div>
                          <div className="pos-pay-footer">
                            <span>Deposits: {item.count}</span>
                            <span className="pos-pay-percent">{((item.value / item.total) * 100).toFixed(1)}%</span>
                          </div>
                        </div>
                      ))
                    : <Empty description="No Data Available" style={{ minWidth: 300 }} />;
                })()}
              </div>
            </Tabs.TabPane>
          </>
        )}

        {/* <!-------------------------------------------- Closing Report ---------------------------------------------------> */}
        {userRole === "admin" && (
          <Tabs.TabPane tab="Daily Closing Report" key="closingReport">
            {/* Date selection and Export button */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 auto', maxWidth: 800, marginBottom: 18 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '14px', color: '#666' }}>Select Date:</span>
                <DatePicker
                  value={closingReportDate}
                  onChange={handleClosingReportDateChange}
                  format="YYYY-MM-DD"
                  style={{ width: '150px' }}
                  placeholder="Select date"
                />
                <Button
                  type="default"
                  onClick={handleResetToToday}
                  style={{ fontSize: '12px' }}
                >
                  Today
                </Button>
              </div>
              <Button
                type="primary"
                onClick={handleClosingReportPrint}
              >
                Export to PDF
              </Button>
              {/* <Button type="default" style={{ width: '150px' }} onClick={handleTransactionDataPrint}>
                <PrinterOutlined /> Print
              </Button> */}
            </div>

            <div className="custom-closing-card" id="closing-report-content" style={{ background: '#fff', borderRadius: 18, boxShadow: '0 2px 12px rgba(229,103,23,0.07)', padding: '32px 36px', maxWidth: 800, margin: '0 auto', marginBottom: 36 }}>
              <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', marginBottom: 24, alignItems: 'center' }}>
                <div style={{ fontSize: 16, color: '#888' }}>Restaurant: <span style={{ color: '#222', fontWeight: 600 }}>{restaurantName}</span></div>
                <div style={{ fontSize: 16, color: '#888' }}>Date: <span style={{ color: '#222', fontWeight: 600 }}>{closingReportDate.format('YYYY-MM-DD')}</span></div>
                <div style={{ fontSize: 16, color: '#888' }}>Time: <span style={{ color: '#222', fontWeight: 600 }}>{currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span></div>
                <div style={{ fontSize: 16, color: '#888' }}>Prepared by: <span style={{ color: '#222', fontWeight: 600 }}>{currentUser}</span></div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 18, marginBottom: 32 }}>
                <div style={{ color: '#888' }}>Gross Sales</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {closingReportData.selectedDateTotalGrossAmount.toFixed(2)}</div>
                <div style={{ color: '#888' }}>Discounts</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {closingReportData.selectedDateTotalDiscount.toFixed(2)}</div>
                <div style={{ color: '#888' }}>Net Sales</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {closingReportData.selectedDateTotalNetAmount.toFixed(2)}</div>
                <div style={{ color: '#888' }}>Services</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {closingReportData.selectedDateTotalService.toFixed(2)}</div>
                <div style={{ color: '#888' }}>Total 10%</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {closingReportData.selectedDateTotalTax.toFixed(2)}</div>
                <div style={{ color: '#888' }}>Revenue</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {closingReportData.selectedDateTotalRevenue.toFixed(2)}</div>
                <div style={{ color: '#888' }}>Total Transactions</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{closingReportData.selectedDateTotalTransactions}</div>
                <div style={{ color: '#888' }}>Average Revenue Per Transaction</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {(closingReportData.selectedDateTotalRevenue / closingReportData.selectedDateTotalTransactions).toFixed(2) || '0.00'}</div>
                <div style={{ color: '#888' }}>Total Pax</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{closingReportData.selectedDateTotalPax}</div>
                <div style={{ color: '#888' }}>Average Revenue Per Pax</div>
                <div style={{ color: '#111', fontWeight: 700 }}>{symbol} {(closingReportData.selectedDateTotalRevenue / closingReportData.selectedDateTotalPax).toFixed(2) || '0.00'}</div>
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: 18, color: '#222', marginBottom: 10 }}>Payment Method Summary</div>
                <Table
                  className="payment-summary-table"
                  columns={paymentSummary}
                  dataSource={selectedDatePaymentSummary}
                  rowKey="method"
                  pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  pageSizeOptions: ['10', '20', '50'],
                  showSizeChanger: selectedDatePaymentSummary.length > 10,
                  showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
                  onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
                  }} 
                  style={{ background: '#fff', borderRadius: 12 }}
                  summary={() => (
                    <Table.Summary.Row>
                      <Table.Summary.Cell><strong>Total</strong></Table.Summary.Cell>
                      <Table.Summary.Cell><strong>{closingReportData.selectedDateTotalTransactions}</strong></Table.Summary.Cell>
                      <Table.Summary.Cell><strong>{closingReportData.selectedDateTotalDepositTransactions}</strong></Table.Summary.Cell>
                      <Table.Summary.Cell><strong>{symbol} {parseFloat(closingReportData.selectedDateTotalRevenue).toFixed(2)}</strong></Table.Summary.Cell>
                    </Table.Summary.Row>
                  )}
                />
              </div>
            </div>
          </Tabs.TabPane>
        )}

            {/* <!------------------------------------------ Today's order ---------------------------------------------------> */}

            <Tabs.TabPane tab="Today's Orders" key="todaysOrders">
              
              <div style={{ marginBottom: "16px" }}>
                <Table
                  columns={todaysOrdersColumns}
                  dataSource={filteredTodaysOrders}
                  bordered
                  loading={todaysOrdersLoading}
                  pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  pageSizeOptions: ['10', '20', '50'],
                  showSizeChanger: filteredTodaysOrders.length > 10,
                  showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
                  onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
                }} 
                  rowKey="_id"
                  defaultSortOrder="descend"
                  locale={{
                    emptyText: (
                      <Empty
                        description="No orders found for today"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </div>
            </Tabs.TabPane>

            {/* <!------------------------------------------ Void Record ---------------------------------------------------> */}

            {userRole === "admin" && (
              <Tabs.TabPane tab={<span>Today's Voided Items</span>} key="voidedItems">
              <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  flexWrap: "wrap",
                    justifyContent: "space-between",
                }}
              >
                  <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                  <RangePicker
                    className="custom-date-picker"
                      value={voidedItemsFilters.dateRange}
                      onChange={handleVoidedItemsDateRangeChange}
                    defaultValue={[startOfDay, endOfDay]}
                    style={{ width: "300px" }}
                    placeholder={["Start Date", "End Date"]}
                  />

                  <TimeRangePicker
                    className="custom-time-picker"
                      value={voidedItemsFilters.timeRange}
                      onChange={handleVoidedItemsTimeRangeChange}
                    format="HH:mm"
                    style={{ width: "300px" }}
                    placeholder={["Start Time", "End Time"]}
                  />
                </div>


                  <Button
                    type="primary"
                    style={{ width: "150px", borderRadius: "8px" }}
                    onClick={handleVoidedItemsPrint}
                    loading={voidedItemsLoading}
                  >
                    Export to Excel
                  </Button>
              </div>

                {/* <div
                style={{
                  marginBottom: "16px",
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <Select
                  className="custom-select-with-icon"
                  placeholder={
                    <span>
                      <UserOutlined
                        style={{
                          marginRight: "8px",
                          fontSize: "16px",
                          color: "#1890ff",
                        }}
                      />
                      User ID
                    </span>
                  }
                  suffixIcon={
                    cashierOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                  }
                    value={voidedItemsFilters.cashier}
                    onChange={handleVoidedItemsCashierChange}
                  style={{ width: 250 }}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                >
                  {cashierName.map((cashier) => (
                    <Select.Option key={cashier} value={cashier}>
                      {cashier}
                    </Select.Option>
                  ))}
                </Select>

                <Select
                  className="custom-select-with-icon"
                  placeholder={
                    <span>
                      <TableOutlined
                        style={{
                          marginRight: "8px",
                          fontSize: "16px",
                          color: "#1890ff",
                        }}
                      />
                      Table Number
                    </span>
                  }
                  suffixIcon={
                    tableOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                  }
                    value={voidedItemsFilters.table}
                    onChange={handleVoidedItemsTableChange}
                  style={{ width: 250 }}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                >
                  {tableNumber.map((table) => (
                    <Select.Option key={table} value={table}>
                      {table}
                    </Select.Option>
                  ))}
                </Select>
                </div> */}

                <Table
                  columns={voidedItemsColumns}
                  dataSource={filteredVoidedItems}
                  bordered
                  loading={voidedItemsLoading}
                  pagination={{
                  current: pagination.current,
                  pageSize: pagination.pageSize,
                  pageSizeOptions: ['10', '20', '50'],
                  showSizeChanger: filteredVoidedItems.length > 10,
                  showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
                  onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
                }} 
                  rowKey="_id"
                  locale={{
                    emptyText: (
                      <Empty
                        description="No voided items found"
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                  summary={() => {
                    const totalQuantity = filteredVoidedItems.reduce(
                      (sum, item) => sum + (item.quantity || 0),
                      0
                    );

                    return (
                      <Table.Summary>
                        <Table.Summary.Row>
                          <Table.Summary.Cell
                            index={0}
                            colSpan={7}
                            align="right"
                          >
                            <strong>Total Quantity:</strong>
                          </Table.Summary.Cell>
                          <Table.Summary.Cell index={1}>
                            <strong>{totalQuantity}</strong>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      </Table.Summary>
                    );
                  }}
                />
              </Tabs.TabPane>
            )}
      </Tabs>
    </DefaultLayout>
  );
};

export default Report;
